import { motion } from "framer-motion";
import { MessageSquareText, AlertTriangle, Hourglass, Mail } from "lucide-react";

const CARD =
  "flex flex-col items-center text-center border border-[#1e293b] rounded-2xl bg-[#121b29]/70 backdrop-blur-md p-8 text-slate-400 max-w-md mx-auto shadow-lg";

export const EmptyState = () => (
  <motion.div
    data-testid="empty-state"
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    className={CARD}
  >
    <div className="h-12 w-12 rounded-full bg-[#0cb0b5]/12 flex items-center justify-center mb-4">
      <MessageSquareText className="h-6 w-6 text-[#0cb0b5]" />
    </div>
    <p className="text-white text-base font-semibold font-heading">Let's get into it.</p>
    <p className="text-sm mt-2 leading-relaxed">
      Pick a starter below or just type.
    </p>
  </motion.div>
);

export const ErrorState = ({ message }) => (
  <motion.div
    data-testid="error-state"
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    className={CARD}
  >
    <div className="h-12 w-12 rounded-full bg-[#f5a524]/12 flex items-center justify-center mb-4">
      <AlertTriangle className="h-6 w-6 text-[#f5a524]" />
    </div>
    <p className="text-white text-base font-semibold font-heading">A quick hiccup</p>
    <p className="text-sm mt-2 leading-relaxed">{message}</p>
  </motion.div>
);

export const RateLimitState = ({ message }) => (
  <motion.div
    data-testid="rate-limit-state"
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    className={CARD}
  >
    <div className="h-12 w-12 rounded-full bg-[#0cb0b5]/12 flex items-center justify-center mb-4">
      <Hourglass className="h-6 w-6 text-[#0cb0b5]" />
    </div>
    <p className="text-white text-base font-semibold font-heading">
      {message || "You've reached the limit for now."}
    </p>
    <p className="text-sm mt-2 leading-relaxed">
      Want to keep the conversation going? Reach the real Thamel directly.
    </p>
    <a
      data-testid="rate-limit-contact"
      href="mailto:mailtothamel@gmail.com"
      className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#0cb0b5] bg-[#0cb0b5]/10 px-4 py-2 text-sm text-white hover:bg-[#0cb0b5]/20 transition-colors duration-200"
    >
      <Mail className="h-4 w-4" />
      Email Thamel
    </a>
  </motion.div>
);
